import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { Outlet } from "react-router-dom";

import headerLogo from './images/uia_logo_header.png';
import headerLogoDark from './images/uia_logo_header_dark.png';

const pages =
    [
        { route: "aktuelles", display: "Aktuelles" },
        { route: "angebote", display: "Angebote" },
        { route: "vereine", display: "Vereine" },
        { route: "kontakt", display: "Kontakt" },
        { route: "impressum", display: "Impressum" }
    ];



function NavBar(props) {

    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <>
            <AppBar position="sticky" enableColorOnDark sx={{ backgroundColor: 'background.paper' }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {/*Desktop View*/}
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="/"
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                color: 'text.primary',
                                textDecoration: 'none',
                            }}
                        >
                            Ultimate im Allgäu
                        </Typography>
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (
                                <Link href={page.route} key={page.route} underline="none">
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'text.primary', display: 'block' }}
                                    >
                                        {page.display}
                                    </Button>
                                </Link>
                            ))}
                        </Box>
                        <IconButton
                            align="right"
                            sx={{ ml: 1, display: { xs: 'none', md: 'flex' } }}
                            onClick={props.colorMode.toggleColorMode}
                            color="text.primary">
                            {props.theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>



                        {/*Mobile View*/}
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color='text.primary'
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page.display} onClick={handleCloseNavMenu}>
                                        <Link href={page.route} underline="none" color="custom.link">
                                            <Typography textAlign="center">{page.display}</Typography>
                                        </Link>
                                    </MenuItem>
                                ))}

                            </Menu>
                        </Box>
                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            align="center"
                            href="/"
                            sx={{
                                display: { xs: 'flex', md: 'none' },
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                color: 'text.primary',
                                textDecoration: 'none',
                            }}
                        >
                            Ultimate im Allgäu
                        </Typography>
                        <IconButton sx={{ mr: 1, display: { xs: 'flex', md: 'none' } }} onClick={props.colorMode.toggleColorMode} color="text.primary">
                            {props.theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>
                    </Toolbar>
                </Container>
            </AppBar>

            {props.theme.palette.mode === 'dark' ?
                <Box
                    component="img"
                    sx={{
                        width: '100%',
                    }}
                    alt="Ultimate im Allgäu Logo Header"
                    src={headerLogoDark}
                />
                :
                <Box
                    component="img"
                    sx={{
                        width: '100%',
                    }}
                    alt="Ultimate im Allgäu Logo Header"
                    src={headerLogo}
                />
            }
            
            <Box className="Content" sx={{ backgroundColor: 'background.paper' }} >
                <Outlet />
            </Box>
        </>
    );
}
export default NavBar;